import { render, staticRenderFns } from "./IntegerField.vue?vue&type=template&id=52e0f907&"
import script from "./IntegerField.vue?vue&type=script&lang=ts&"
export * from "./IntegerField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports